.loadingButton {
  color: transparent !important;
  pointer-events: none;
  position: relative;

  > div:not([loaderlight]) {
    opacity: 0;
  }
}